import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';
import { EmailVerificationForm } from 'src/app/shared/forms/auth/email-verification.form';
import { AuthStoreService } from 'src/app/shared/services/auth/auth-store.service';
import { AnalyticsFormService } from '../../../core/services/analytics-form.service';
import { EmailVerificationService } from '../../../shared/services/auth/email-verification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { LoaderButtonType } from '../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-email-verification',
  styleUrls: ['./email-verification.component.scss'],
  templateUrl: './email-verification.component.html',
})
export class EmailVerificationComponent implements OnInit {
  public form: EmailVerificationForm;

  public loading: boolean;
  public verificationCodeResent = false;
  public emailAlreadyConfirmed = false;
  public errors: string[];
  public errorMessages = {
    VERIFICATION_CODE_INVALID: 'Kod weryfikacyjny jest nieprawidłowy lub stracił ważność.',
  };

  public formName = 'emailVerification';

  constructor(
    public authStore: AuthStoreService,
    private route: ActivatedRoute,
    private emailVerificationService: EmailVerificationService,
    private analyticsFormService: AnalyticsFormService,
  ) {
  }

  public ngOnInit(): void {
    const verificationCode = (this.route.snapshot.paramMap.get('verificationState') || '').replace('-', '');
    this.form = new EmailVerificationForm(verificationCode);

    this.emailVerificationService.trackVerificationStartedEvent();
  }

  public verifyEmail(): void {
    if (this.form.valid) {
      this.loading = true;
      this.emailVerificationService.verify(this.form.value).subscribe(
        () => (this.loading = false),
        (errors) => {
          this.errors = errors;
          this.form.verificationState.setErrors({});
          this.analyticsFormService.sendEventForCaughtError('verificationState', this.formName);
          this.loading = false;
        },
      );
    } else {
      this.analyticsFormService.sendEventForInvalidControls(this.form.controls, this.formName);
    }
  }

  public resendVerificationEmail(): void {
    this.authStore
      .resendEmailVerification()
      .pipe(tap(() => (this.verificationCodeResent = true)),
        catchError((err: HttpErrorResponse) => {
          if (err.status === 409) {
            this.emailAlreadyConfirmed = true;
          }
          return throwError(() => err);
        }))
      .subscribe();
  }

  public discontinueEmailVerification(path: string = ''): void {
    this.authStore.discontinueEmailVerification(path).subscribe();
  }

  public goToApp(): void {
    this.emailVerificationService.redirectAfterEmailVerification();
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
